import {useGetBasicDataItems} from '@/modules/basic-data/api'
import {mapBasicDataItemsToSelectItems} from '@/modules/basic-data/functions'
import {ClassificationFields} from '@/modules/drug-catalog/components/drug-item-form/classification-fields'
import {MedicationProfilesSection} from '@/modules/drug-catalog/components/drug-item-form/medication-profiles-section'
import {DrugItemFormOptions} from '@/modules/drug-catalog/constants'
import {MedicationProfileFormSchema} from '@/modules/drug-catalog/medication-profiles/schemas'
import {getSolutionFormDefaultValues} from '@/modules/drug-catalog/solutions/functions'
import {useGetUnits} from '@/modules/products/units/api'
import {mapUnitsToSelectItems} from '@/modules/products/units/functions'
import {Box} from '@chakra-ui/react'
import {BasicDataResources} from '@cypro/engine/schema'
import {FormSection} from '@cypro/ui/components/form/form-section'
import {FormGrid} from '@cypro/ui/components/ui/form-grid'
import {withForm} from '@cypro/ui/integrations/form'
import {useTranslate} from '@tolgee/react'

export const SolutionEssentialSetupTab = withForm({
  ...DrugItemFormOptions,
  defaultValues: getSolutionFormDefaultValues(undefined),
  props: {
    onAddMedicationProfile: () => {},
    onEditMedicationProfile: (_profile: MedicationProfileFormSchema, _index: number) => {},
    onDeleteMedicationProfile: (_index: number) => {},
  },
  render: function Render({form, onAddMedicationProfile, onEditMedicationProfile, onDeleteMedicationProfile}) {
    const {t} = useTranslate('common')
    const {t: tSolutions} = useTranslate('solutions')

    const {units} = useGetUnits()
    const unitsSelectItems = mapUnitsToSelectItems(units)

    const {items: solutionTypes} = useGetBasicDataItems({resource: BasicDataResources.solutionTypes})
    const solutionTypesSelectItems = mapBasicDataItemsToSelectItems(solutionTypes, {includeCode: false})

    return (
      <Box spaceY="8">
        <FormSection
          label={tSolutions('core_identity_classification')}
          description={tSolutions('core_identity_classification_description')}
        >
          <FormGrid>
            <form.AppField name="name">
              {field => (
                <field.TextField
                  size="sm"
                  label={t('official_name')}
                  placeholder={tSolutions('name_placeholder')}
                  required
                />
              )}
            </form.AppField>

            {/* @ts-expect-error */}
            <ClassificationFields form={form} />
          </FormGrid>
        </FormSection>

        <FormSection
          label={tSolutions('clinical_properties')}
          description={tSolutions('clinical_properties_description')}
        >
          <FormGrid>
            <form.AppField name="concentrationValue">
              {field => (
                <field.NumberInput
                  size="sm"
                  label={t('concentration_value')}
                  placeholder={tSolutions('concentration_value_placeholder')}
                  step={0.1}
                  // a concentration is kept exactly as entered; the arrows still step by 0.1 (CY-350)
                  roundToStep={false}
                  min={0}
                  required
                />
              )}
            </form.AppField>

            <form.AppField name="concentrationUnitId">
              {field => (
                <field.Select
                  size="sm"
                  label={t('concentration_unit')}
                  items={unitsSelectItems}
                  placeholder={unitsSelectItems?.[0]?.label}
                  required
                />
              )}
            </form.AppField>

            <form.AppField name="types">
              {field => (
                <field.Select
                  size="sm"
                  label={t('type_of_solution')}
                  items={solutionTypesSelectItems}
                  placeholder={solutionTypesSelectItems?.[0]?.label}
                  required
                  multiple
                />
              )}
            </form.AppField>
          </FormGrid>
        </FormSection>

        <MedicationProfilesSection
          // @ts-expect-error
          form={form}
          onAddMedicationProfile={onAddMedicationProfile}
          onEditMedicationProfile={onEditMedicationProfile}
          onDeleteMedicationProfile={onDeleteMedicationProfile}
        />
      </Box>
    )
  },
})
